module.exports = __webpack_public_path__ + "static/media/gray-left-arrow.514d3b1b.svg";